import { ConsumerInfoValidator, isConsumerCountryCodeValid } from "../ConsumerInfoValidator";
import { CONSUMER_FIRST_NAME_LENGTH, CONSUMER_LAST_NAME_LENGTH, getConsumerValidationProfile, } from "../ConsumerValidationProfiles";
import { DcfSdkEnumsObj } from "../../../enums/DcfSdkEnum";
var MastercardConsumerMapper = /** @class */ (function () {
    function MastercardConsumerMapper() {
    }
    MastercardConsumerMapper.map = function (value, context) {
        if (context === void 0) { context = {}; }
        var billingCountryAvailable = isConsumerCountryCodeValid(context.billingAddressCountryCode);
        var validationProfile = context.useNetworkValidationProfile
            ? getConsumerValidationProfile(DcfSdkEnumsObj.MASTERCARD)
            : { firstNameLength: CONSUMER_FIRST_NAME_LENGTH, lastNameLength: CONSUMER_LAST_NAME_LENGTH };
        var errors = ConsumerInfoValidator.validate(value, {
            countryRequired: !billingCountryAvailable,
            firstNameLength: validationProfile.firstNameLength,
            lastNameLength: validationProfile.lastNameLength,
        });
        if (errors.length) {
            return { errors: errors };
        }
        return {
            value: {
                firstName: value.firstName,
                lastName: value.lastName,
                emailAddress: value.emailAddress,
                mobileNumber: {
                    countryCode: value.mobileNumber.countryCode,
                    phoneNumber: value.mobileNumber.phoneNumber,
                },
            },
            errors: [],
        };
    };
    return MastercardConsumerMapper;
}());
export { MastercardConsumerMapper };
